import { ILanguage } from "src/consts/locale";

export const getLocale = (language: ILanguage) => (language === "de" ? "de-DE" : "en-US");
